module.exports = __webpack_public_path__ + "img/pdc.3b3169fa.webp";